import { bookingsListTypes } from './actionTypes';

const INIT_STATE = {
    bookingsListData: [],
    milestoneConfig: [],
    CountItems: 0,
    isLoading: false,
    error: {},
};

const bookingsList = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case bookingsListTypes.GET_BOOKINGS_LIST:
            return {
                ...state,
                isLoading: true,
            };
        case bookingsListTypes.GET_BOOKINGS_LIST_SUCCESS:
            return {
                ...state,
                bookingsListData: action.payload.BookingData,
                CountItems: action.payload.CountItems,
                isLoading: false,
            };
        case bookingsListTypes.GET_BOOKINGS_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
            };
        case bookingsListTypes.GET_MILESTONESCONFIG_BK_SUCCESS:
            return {
                ...state,
                milestoneConfig: action.payload,
            };
        case bookingsListTypes.GET_MILESTONESCONFIG_BK_FAIL:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default bookingsList;
